module.exports = __webpack_public_path__ + "static/media/arrow.cabb9d42.svg";